/** 用户token */
export const ACCESS_TOKEN_KEY = 'DSY_TOKEN';
export const ACCESS_SITE_KEY = 'DSY_SITE';

/** 电商园的cookie */
export const DSY_TOKEN_KEY = 'dsy_token';
export const DSY_SITE_KEY = 'dsy_site_code';
export const DSY_TOKEN_KEY_COOKIE = 'token';

/** 国际化 */
export const LOCALE_KEY = 'LOCALE__';

/** 主题色 */
export const THEME_KEY = 'THEME__';

/** app隐私协议 */
export const AGREED_PRIVACY_KEY = 'AGREED_PRIVACY__';

/** 用户信息 */
export const USER_INFO_KEY = 'USER__INFO__';

// role info key
export const ROLES_KEY = 'ROLES__KEY__';
/** 是否锁屏 */
export const IS_LOCKSCREEN = 'IS_LOCKSCREEN';
/** 标签页 */
export const TABS_ROUTES = 'TABS_ROUTES';

export const PRINTER_NAME = 'PRINTER_NAME';

export const TEST_ORIGIN = 'https://www.52dsy.com';

export const REMEMBER_ME = 'rememberMe';

export const LAST_VISIT = 'LAST_VISIT';

// 图片是否压缩
export const PICTURE_COMPRESS = 'PICTURE_COMPRESS';
// 图片压缩 资料
export const PICTURE_COMPRESS_QUALITY = 'PICTURE_COMPRESS_QUALITY';

// 是否打开提示音
export const REMINDERS_STATUS = 'REMINDERS_STATUS';
